import { Link, useLocation } from "react-router-dom";
import { Compass } from "@phosphor-icons/react";

const NAV_LINKS = [
  { to: "/", label: "Field Guide", testId: "nav-home" },
  { to: "/spotter-log", label: "Spotter Log", testId: "nav-spotted-log" },
  { to: "/bigfoot-history", label: "Bigfoot in NM", testId: "nav-bigfoot" },
  { to: "/about", label: "About El Porvenir", testId: "nav-about" },
];

export default function Layout({ children }) {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col" data-testid="app-shell">
      <header
        className="sticky top-0 z-40 backdrop-blur-md bg-[#F4F1EA]/85 border-b border-[#D1C9B8]"
        data-testid="site-header"
      >
        <div className="max-w-7xl mx-auto px-5 md:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 group" data-testid="nav-logo">
            <Compass size={22} weight="duotone" className="text-[#2A3A2C]" />
            <div className="leading-tight">
              <div className="font-serif-display text-xl text-[#2A3A2C]">El Porvenir</div>
              <div className="font-mono-label text-[10px] text-[#5C6B5E] -mt-0.5">
                Wildlife · A Field Guide
              </div>
            </div>
          </Link>
          <nav className="flex items-center gap-7">
            {NAV_LINKS.map((link) => {
              const active =
                link.to === "/"
                  ? location.pathname === "/"
                  : location.pathname.startsWith(link.to);
              return (
                <Link
                  key={link.to}
                  to={link.to}
                  data-testid={link.testId}
                  className={`font-mono-label text-[11px] link-quill ${
                    active ? "text-[#2A3A2C]" : "text-[#5C6B5E] hover:text-[#2A3A2C]"
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </nav>
        </div>
      </header>

      <main className="flex-1">{children}</main>

      <footer
        className="border-t border-[#D1C9B8] bg-[#FAF8F5] mt-24"
        data-testid="site-footer"
      >
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-12 grid md:grid-cols-3 gap-10">
          <div>
            <div className="font-serif-display text-2xl text-[#2A3A2C]">El Porvenir</div>
            <p className="font-mono-label text-[10px] text-[#5C6B5E] mt-1">
              San Miguel County · New Mexico
            </p>
            <p className="text-sm text-[#5C6B5E] mt-4 leading-relaxed">
              A community field guide to the creatures of the Sangre de Cristo
              foothills — from cold trout streams to old-growth conifer canyons.
            </p>
          </div>
          <div>
            <div className="font-mono-label text-[10px] text-[#5C6B5E]">Sections</div>
            <ul className="mt-3 space-y-2 text-sm">
              <li><Link to="/" className="link-quill text-[#2A3A2C]">Field Guide</Link></li>
              <li><Link to="/spotter-log" className="link-quill text-[#2A3A2C]">Spotter Log</Link></li>
              <li><Link to="/bigfoot-history" className="link-quill text-[#2A3A2C]">Bigfoot in NM</Link></li>
              <li><Link to="/about" className="link-quill text-[#2A3A2C]">About</Link></li>
            </ul>
          </div>
          <div>
            <div className="font-mono-label text-[10px] text-[#5C6B5E]">Field Notes</div>
            <p className="text-sm text-[#5C6B5E] mt-3 leading-relaxed">
              Observe at a distance. Pack out what you pack in. Leave the wildflowers.
              The mountain remembers everything.
            </p>
          </div>
        </div>
        <div className="border-t border-[#D1C9B8]">
          <div className="max-w-7xl mx-auto px-5 md:px-8 py-5 flex justify-between text-[10px] font-mono-label text-[#5C6B5E]">
            <span>© {new Date().getFullYear()} El Porvenir Wildlife Guide</span>
            <span>Vol. I · Field Edition</span>
          </div>
        </div>
      </footer>
    </div>
  );
}
